<template>
  <z-dialog
    ref="map-dialog"
    class="map-dialog"
    type="confirm"
    title="选择店铺地图定位"
    @ok="onOk"
    @cancel="onCancel"
  >
    <iframe class="map-tencent" frameborder="0" :src="getMapUrl"> </iframe>
  </z-dialog>
</template>

<script>
export default {
  props: {
    isMapShow: {
      type: Boolean,
      required: true
    },
    mapKey: {
      type: String,
      required: true
    },
    longitude: {
      type: [Number, String],
      default: null
    },
    latitude: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      longitudeCopy: null,
      latitudeCopy: null
    }
  },
  computed: {
    // 获取地图url
    getMapUrl() {
      const url = 'https://apis.map.qq.com/tools/locpicker?'
      const query = ['search=1', 'type=1', 'referer=ourchoice', `key=${this.mapKey}`]
      if (this.longitude && this.latitude) {
        query.push(`coord=${this.latitude},${this.longitude}`)
      }
      return url + query.join('&')
    }
  },
  created() {},
  mounted() {
    this.initMap()
    this.longitudeCopy = this.longitude
    this.latitudeCopy = this.latitude
    this.openMap()
  },
  methods: {
    // 初始化地图
    initMap() {
      window.addEventListener('message', this.updateMap, true)
    },
    // 更新地图
    updateMap(event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
      const loc = event.data
      if (loc && loc.module == 'locationPicker') {
        this.longitudeCopy = loc.latlng.lng.toFixed(6)
        this.latitudeCopy = loc.latlng.lat.toFixed(6)
      }
    },
    // 打开地图弹窗
    openMap() {
      this.$refs['map-dialog'].open()
    },
    // 关闭地图弹窗
    closeMap() {
      this.$emit('update:isMapShow', false)
    },
    // 确定
    onOk() {
      this.$emit('update:longitude', this.longitudeCopy)
      this.$emit('update:latitude', this.latitudeCopy)
      this.$emit('change', { longitude: this.longitudeCopy, latitude: this.latitudeCopy })
      this.closeMap()
    },
    // 取消
    onCancel() {
      this.closeMap()
    }
  }
}
</script>

<style lang="postcss">
.map-dialog {
  .dialog-box {
    width: 800px;
    height: 600px;
    margin: -300px -400px;
    .content {
      margin: 0 0 20px 0;
      height: 460px;
      .map-tencent {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
